import React, { Component } from 'react';
import Questionnaire from './js/components/questionnaire';
import {QuestionsProvider} from './js/context/questions'
import './App.css';
import dataJson from './data/data.json';


let data = undefined;

export default class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      //If using local, use a json feed, otherwise use the jsEntity
      data = window.drupalSettings
      ? window.drupalSettings.jsEntity
      : dataJson;

      if (data !== undefined) {

        console.log("data loaded: ", data);

        this.setState({
          data: data.questionnaire,
          isLoading: false,
        });
        clearInterval(this.interval);

      } else {
        console.log("data undefined", data);
        this.setState({
          error:
            "There was an error loading the data. Please reload the page.",
          isLoading: false
        });
        clearInterval(this.interval);
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  
  render() {

    return (
      <div className="react--wrapper">
        {this.state.isLoading ? (
          <div className="loader" />
        ) : (
          <QuestionsProvider data={this.state.data}>
            <Questionnaire/>
          </QuestionsProvider>
        )}
      </div>
    );
  }
}
